import { 
  getFirestore, collection, addDoc, getDoc, doc, serverTimestamp, 
  query, where, orderBy, limit, getDocs  
} from "firebase/firestore"; // Add Firestore methods
import { auth } from "./firebase"; // Import auth

const db = getFirestore();

// Function to check if the email is whitelisted
export const isEmailWhitelisted = async (email) => {
    console.log("Current user:", auth.currentUser); // Check if user is authenticated
  try {
    const docRef = doc(db, "whitelist", email); // Reference to the document
    const docSnap = await getDoc(docRef); // Fetch the document
    return docSnap.exists(); // Returns true if the document exists
  } catch (error) {
    console.error("Error checking whitelist:", error);
    return false; // Return false on error
  }
};

// Function to submit feedback
export const submitFeedback = async (feedbackData) => {
  try {
    const feedbackCollection = collection(db, "feedback");
    await addDoc(feedbackCollection, {
      ...feedbackData,
      timestamp: serverTimestamp(), // Automatically set the timestamp
    });
    console.log("Feedback submitted successfully");
  } catch (error) {
    console.error("Error submitting feedback:", error);
  }
};

// 🔥 Define fetchSavedAnalyses
export const fetchSavedAnalyses = async () => {
  const userEmail = auth.currentUser?.email;
  if (!userEmail) return [];

  try {
    console.log("🔄 Fetching saved analyses for:", userEmail);

    const analysesRef = collection(db, "savedAnalyses");
    const userQuery = query(
      analysesRef,
      where("userEmail", "==", userEmail),
      orderBy("timestamp", "desc"),
      limit(5)
    );
    const userDocs = await getDocs(userQuery);

    const loadedAnalyses = userDocs.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    console.log("✅ Loaded saved analyses:", loadedAnalyses);
    return loadedAnalyses; // ✅ Return fetched analyses

  } catch (error) {
    console.error("🔥 Error loading saved analyses:", error);
    return []; // Return empty array on error
  }
};

export { db };